import { useQuery } from '@tanstack/react-query';

import { getHubspotSyncHealth } from '../api/syncHealth';
import type { HubspotSyncHealthResponse } from '../types';

export function useHubspotSyncHealth(orgId: number | string | undefined) {
  return useQuery<HubspotSyncHealthResponse>({
    queryKey: ['hubspotSyncHealth', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getHubspotSyncHealth(orgId);
    },
    enabled: !!orgId,
    refetchInterval: query => (query.state.data?.connected ? 30000 : false),
  });
}
